<template>
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-logo">
            <h3>Emily & David</h3>
            <p>2025.06.15</p>
          </div>
          <div class="footer-links">
            <ul>
              <li><a href="#home">首頁</a></li>
              <li><a href="#our-story">我們的故事</a></li>
              <li><a href="#gallery">相簿</a></li>
              <li><a href="#event">婚禮資訊</a></li>
              <li><a href="#rsvp">RSVP</a></li>
              <li><a href="#gifts">禮物</a></li>
            </ul>
          </div>
          <div class="footer-social">
            <a href="#" class="social-icon"><i class="fab fa-instagram"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-facebook"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-pinterest"></i></a>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; {{ new Date().getFullYear() }} Emily & David. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  </template>

<script>
export default {
  name: 'AppFooter' // ✅ 改為多字名稱
}
</script>

<!-- ✅ 匯入你的樣式檔 -->
<style src="@/assets/css/footer.css" scoped></style>